<template>
  <div class="row">
    <div v-if="show_project_picture" class="col-1  ">
      <div class="mt-1">
        <div class="project_pic shadow-sm"></div>
      </div>
    </div>
    <div :class="[show_project_picture ? 'col-11': 'col-12']">
      <select v-if="task_mode" :ref="'projectSelect'+unique_id" :id="'projectSelect'+unique_id"
              v-model="selected_task.project_id"  class="form-control form-control-sm mb-2" data-toggle="select">
        <option :selected="selected_task.project_id" v-for="project in projects_by_assignee"
                :value="project._id" :data-position="project.is_personal ? $t('elements.project_select.private') : $t('elements.project_select.public')"
                :key="project._id">
          {{project.name}}
        </option>
      </select>
      <select v-else-if="create_task_modal" :ref="'projectSelect'+unique_id" :id="'projectSelect'+unique_id" v-model="task_template.project_id"  class="form-control form-control-sm mb-2" data-toggle="select">
        <option :selected="task_template.project_id === project._id" v-for="project in projects_by_account_id"
                :value="project._id" :data-position="project.is_personal ? $t('elements.project_select.private') : $t('elements.project_select.public')"
                :key="project._id">
          {{project.name}}
        </option>
      </select>
      <select v-else :ref="'projectSelect'+unique_id" :id="'projectSelect'+unique_id" v-model="selected_project_id"  class="form-control form-control-sm mb-2" data-toggle="select">
        <option :selected="selected_project_id === project._id" v-for="project in projects"
                :value="project._id" :data-position="project.is_personal ? $t('elements.project_select.private') : $t('elements.project_select.public')"
                :key="project._id">

          {{project.name}}
        </option>
      </select>
    </div>
  </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  import Noty from 'noty';

  export default {
    name: 'projectSelect',
    props: {
      show_all_projects: {
        default: true,
      },
      show_project_picture: {
        default: false,
      },
      task_mode: {
        default: false,
      },
      create_task_modal: {
        default: false,
      },

    },
    data: function () {
      return {
        unique_id: '1',
        temporarilySelectedProject: this.task_,
      };
    },
    computed: {
      ...mapGetters([
        'account',
        'projects',
        'selected_account_id',
        'selected_project_id',
        'selected_task',
        'task_template',
      ]),
      projects_by_assignee: function () {
        return this.projects.filter(project => project.members.indexOf(this.selected_task.assignee) > -1);
      },
      projects_by_account_id: function () {
        return this.projects.filter(project => project.members.indexOf(this.selected_account_id) > -1);
      },
    },
    watch: {
      projects: function (newVal, oldVal) {
        this.enableSelect();
      },
      selected_project_id: function (newVal, oldVal) {
        if (!this.task_mode) {
          this.enableSelect();
        }
      },
      'task_template.project_id': function (newVal, oldVal) {
        if (!this.task_mode) {
          this.enableSelect();
        }
      },
      selected_task: function () {
        if (this.task_mode) {
          this.enableSelect();
        }
      },

    },
    methods: {
      enableSelect () {
        const self = this;
        function initSelect ($this) {
          var options = {
            // eslint-disable-next-line no-undef
            dropdownParent: $this.closest('.modal').length ? $this.closest('.modal') : $(document.body),
            minimumResultsForSearch: $this.data('minimum-results-for-search'),
            templateResult: formatAvatar,
          };
          $this
            .select2(options)
            .on('change', function () {
              if (self.task_mode) {
                const assigneeProjects = self.projects.filter(project => project.members.indexOf(self.selected_task.assignee) > -1);
                if (assigneeProjects.filter(project => project._id === this.value).length) {
                  self.selected_task.project_id = this.value;
                } else {
                  self.temporarilySelectedProject = this.value;
                  const n = self.$noty.error('Assignee is not a member of the project.<br> Do you want to add him as a member?', {
                    modal: true,
                    layout: 'center',
                    timeout: 10000,
                    buttons: [
                      Noty.button('YES', 'btn btn-primary', function () {
                        self.addMember(self.temporarilySelectedProject);
                        self.$store.dispatch('fetchProjects');
                        n.close();
                      }, { id: 'button1', 'data-status': 'ok' }),

                      Noty.button('NO', 'btn btn-secondary ml-1', function () {
                        self.$store.dispatch('fetchProjects');
                        n.close();
                      }),
                    ],
                    killer: true,
                    callbacks: {
                      onClose () {
                        // self.$noty.closeAll();
                        self.$store.dispatch('fetchProjects');
                      },
                    },
                    closeWith: ['button'],
                  });
                }
              } else if (self.create_task_modal) {
                self.task_template.project_id = this.value;
                self.$store.commit('setSelectedProjectId', this.value);
              } else {
                self.$store.commit('setSelectedProjectId', this.value);
              }
            });
        }

        function formatAvatar (avatar) {
          if (!avatar.id) {
            return avatar.text;
          }
          // eslint-disable-next-line no-undef
          var $option = $(avatar.element);
          var optionAvatar = $option.data('avatar-src');
          var optionPosition = $option.data('position');
          let output = '';
          if (optionAvatar) {
            // eslint-disable-next-line no-undef
            output = $('<span class="avatar avatar-xs mr-3"><img class="avatar-img rounded-circle" src="' + optionAvatar + '" alt="..."></span>');
          }
          output += '<span>' + avatar.text + '</span>';
          if (optionPosition) {
            if (optionPosition === 'low') {
              optionPosition = '123';
            }
            output += '<span class="small badge badge-soft-dark text-white float-right">' + optionPosition + '</span>';
          }
          // eslint-disable-next-line no-undef
          return $(output);
        }
        // eslint-disable-next-line no-undef
        setTimeout(() => initSelect($(document.getElementById('projectSelect' + self.unique_id))), 100);
      },
      addMember (projectId) {
        const selectedProject = this.projects.filter(project => project._id === projectId)[0];
        if (!(selectedProject.members.indexOf(this.selected_task.assignee) >= 0) && !selectedProject.is_personal) {
          selectedProject.members.push(this.selected_task.assignee);
          this.$store.dispatch('updateProject', selectedProject);
          this.$noty.success('Project changes were saved successfully. Now you can change project.');
        } else if (selectedProject.is_personal) {
          this.$noty.show('You can not move other member\'s task to your personal project');
        } else {
          this.$noty.show('This member is already within the project');
        }
      },
    },
    created () {
      this.unique_id = Math.random().toString();
      this.enableSelect();
    },

  };
</script>

<style>
  .select2.select2-container {
    margin-top: 0;
  }
</style>

<style scoped>

  .project_pic {
    border-radius: 4px;
    /*background: linear-gradient(#e66465, #9198e5);*/
    background: linear-gradient(217deg, rgba(255,0,0,.8), rgba(255,0,0,0) 70.71%),
    linear-gradient(127deg, rgba(0,255,0,.8), rgba(0,255,0,0) 70.71%),
    linear-gradient(336deg, rgba(0,0,255,.8), rgba(0,0,255,0) 70.71%);
    padding: 0px;
    opacity: 80%;
    width: 20px;
    height: 22px;

  }
  .addAssigneeButton {
    border-radius: 4px;
    background-color: #F8D7DD;
    border: 0.5px solid #FFB9C6;
  }
  .addAssigneeText {
    color: #E43A5A;
  }

</style>
